import type { GeneratedSchemaField } from '@cli-types/core-engine/add-field.js'

export function fieldTypeOf(field: GeneratedSchemaField): string {
  return typeof field.type === 'string' ? field.type : 'field'
}
